// src/navigationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showPopup: false,
  trigger: false,
  backClicked: false,
  isSettings: false,
  name: "",
  newNav: {},
  navigate: false,
  navLink: "",
};

const navPopupSlice = createSlice({
  name: "navPopup",
  initialState,
  reducers: {
    updatenavPopup: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetnavPopup: (state, action) => {
      return initialState; // Reset to initial stat
    },
    setShowPopupTrue: (state, action) => {
      console.log("setting show popup to true");

      return {
        ...state,
        showPopup: true,
      }; // Reset to initial stat
    },
    setShowPopupFalse: (state, action) => {
      return {
        ...state,
        showPopup: false,
      }; // Reset to initial stat
    },
  },
});

export const {
  updatenavPopup,
  resetnavPopup,
  setShowPopupTrue,
  setShowPopupFalse,
} = navPopupSlice.actions;

export default navPopupSlice.reducer;
